import React, { useEffect, useState } from "react";
import TextCapsule from "../../../../../common/TextCapsule";

import { nextCard } from "../../../../../redux/slices/CardSlices";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import { getInsuranceTypes } from "../../../../../services/yourAssets/InsuranceServices";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AddList = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSetProperties, selectedProperties, nextCard } = props;
  const [propertyInsurances, setPropertyInsurances] = useState([]);
  const [personalInsurances, setPersonalInsurances] = useState([]);

  const getInsuranceTypesList = async () => {
    let apiResult = await getInsuranceTypes(id);
    if (apiResult?.success) {
      const personalTypes = apiResult?.payLoad
        .filter((el) => el.parentCategoryId === 1)
        .map((el) => {
          return {
            id: el.insuranceCategoryId,
            name: el.name,
            type: "personal",
            translationKey: el?.translationKey || "",
          };
        });
      const assetsTypes = apiResult?.payLoad
        .filter((el) => el.parentCategoryId === 2)
        .map((el) => {
          return {
            id: el.insuranceCategoryId,
            name: el.name,
            type: "assets",
            translationKey: el?.translationKey || "",
          };
        });
      setPropertyInsurances(personalTypes);
      setPersonalInsurances(assetsTypes);
    }
  };

  useEffect(() => {
    getInsuranceTypesList();
  }, []);
  const handleClickOnList = (obj, type) => {
    handleSetProperties({ ...obj, type });
  };
  const handleClick = () => {
    if (selectedProperties?.length) {
      nextCard();
    }
  };

  const selection = propertyInsurances.map((el) => {
    return (
      <TextCapsule
        key={el.id}
        title={t(el.translationKey)}
        click={() => handleClickOnList(el, "assets")}
        width="fit-content"
        minWidth="150px"
        padding="5px 14px"
        margin="0.6rem 1rem"
        bgColor={
          selectedProperties.some((item) => {
            if (item.id === el.id) return true;
            return false;
          })
            ? "color.magentaLight2"
            : "color.lightGrey"
        }
        color={
          selectedProperties.some((item) => {
            if (item.id === el.id) return true;
            return false;
          })
            ? "color.black"
            : "color.midGrey"
        }
      />
    );
  });
  const selection1 = personalInsurances.map((el) => {
    return (
      <TextCapsule
        key={el.id}
        title={t(el.translationKey)}
        click={() => handleClickOnList(el, "personal")}
        minWidth="150px"
        width="238px"
        margin="0.6rem 1rem"
        padding="5px 14px"
        bgColor={
          selectedProperties.some((item) => {
            if (item.id === el.id) return true;
            return false;
          })
            ? "color.magentaLight2"
            : "color.lightGrey"
        }
        color={
          selectedProperties.some((item) => {
            if (item.id === el.id) return true;
            return false;
          })
            ? "color.black"
            : "color.midGrey"
        }
      />
    );
  });
  return (
    <div className="insurance-list-container">
      <Grid
        container
        sx={{
          margin: "0 auto",
          background: "white",
          boxShadow:
            "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
          padding: "25px 20px 15px 20px",
          borderRadius: "5px",
          maxWidth: "600px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box>
            <Typography sx={{ textAlign: "center", marginBottom: "1rem" }}>
              {t("i-types-heading-1")}
            </Typography>
            {selection}
          </Box>
          <Box>
            <Typography sx={{ textAlign: "center", marginBottom: "1rem" }}>
              {t("i-types-heading-2")}
            </Typography>
            {selection1}
          </Box>
        </Box>
        <Grid
          item
          lg={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            sx={{
              backgroundColor: `${!selectedProperties?.length
                  ? "color.dimGrey"
                  : "color.magentaMid2"
                }`,
              color: "color.white",
              padding: "5px 28px",
              borderRadius: "14px",
              margin: ".2rem 1rem .4rem 0",
              border: "none",
              textTransform: "initial",
              "&:hover": {
                backgroundColor: "color.magentaLight2",
                color: "color.white",
                boxShadow: "none",
              },
            }}
            disabled={!selectedProperties?.length}
            onClick={() => handleClick()}
          >
            {t("add-to-list")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
  };
}

export default connect(null, mapDispatchToProps)(AddList);
